import React from "react";
import Loginleft from "../components/Loginleft";
import Login1 from "../components/Login1";

const Login = () => {
  return (

      <div className="row g-0 min-100vh flex-column flex-lg-row justify-content-center">

        <Login1 />
      </div>
   
  );
};

export default Login;
